module.exports = __webpack_public_path__ + "img/robot_mobile.0bcb24c4.png";